import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { recordLocalAtom, topMessageAtom, recordTypeAtom } from '../../State';
import { useLocalSessionId, useDaily, useDailyEvent } from '@daily-co/daily-react';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { ReactComponent as CopyLinkSVG } from '../Images/buttons/linkCopyGray.svg';
import { useParams } from 'react-router-dom';
import DataModel from '../Util/DataModel';
import AddAccess from '../Util/AddAccess';
import { useTranslation } from 'react-i18next';
import RecordRTC, { DiskStorage, getSeekableBlob } from 'recordrtc';
import axios from 'axios';
import { render } from 'react-dom';
//import { clearInterval, clearTimeout, setInterval, setTimeout } from 'worker-timers';
//import { Credentials, S3 } from 'aws-sdk';
//import { Upload } from '@aws-sdk/lib-storage';
//import { S3Client, put } from '@aws-sdk/client-s3';

export default function RecordLocal({ canvasRef }) {
  //Daily系
  const callObject = useDaily();
  const localSessionId = useLocalSessionId();
  const { t } = useTranslation();

  //Recoil系
  const [recordLocalState, setRecordLocalState] = useRecoilState(recordLocalAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const [recordTypeState, setRecordTypeState] = useRecoilState(recordTypeAtom);

  //その他
  const recorderRef = useRef(null);
  const recordingUsersRef = useRef([]);
  const isRecordingRef = useRef(false);
  const mediaTypeRef = useRef(null);
  const mediaData = useRef([]);
  const mimeType = useRef('video/webm;codecs=vp9');
  const audioSourceNode = useRef(null);
  const destinationNode = useRef(null);
  const audioContext = useRef(null);
  const overMinSize = useRef(false);
  const recordType = useRef('local');
  const videoURL = useRef(null);
  const [recordingState, setRecordingState] = useState(null);
  const [showDownloadURL, setShowDownloadURL] = useState(false);
  const recordedIDRef = useRef(null);

  const urlParam = useParams();

  useEffect(() => {
    recordType.current = recordTypeState;
  }, [recordTypeState]);

  //ローカル保存
  useEffect(() => {
    if (recordType.current != 'local') return;

    //録画開始
    if (recordLocalState) {
      recordCanvasStart();
      AddAccess('click', 'startRecordingLocal');
    }
    //録画停止
    else {
      if (recorderRef.current != null) {
        //recorderRef.current.stop();
        recorderRef.current.stopRecording(function () {
          // let indexDBfile = recorderRef.current.getFromDisk();

          // console.log(indexDBfile);

          let fileName;
          if (mimeType.current == 'video/mp4') {
            fileName = `FACELESS-Video.mp4`;
          } else {
            fileName = `FACELESS-Video.webm`;
          }
          recorderRef.current.save(fileName);

          // DiskStorage.dataStoreName = 'facelessIndexDB';
          // DiskStorage.Store({ videoBlob: recorderRef.current.getBlob() });

          // DiskStorage.Fetch(function (dataURL, type) {
          //   if (type === 'videoBlob') {
          //     console.log('indexDBのデータ');
          //     console.log(dataURL);
          //   }
          // });

          //let blob = recorderRef.current.getBlob();
          //invokeSaveAsDialog(blob);
          //保存する
          // const url = window.URL.createObjectURL(blob);
          // const a = document.createElement('a');
          // if (mimeType.current == 'video/mp4') {
          //   a.download = `FACELESS-Video.mp4`;
          // } else {
          //   a.download = `FACELESS-Video.webm`;
          // }

          // a.href = url;
          // a.click();

          //リセット
          setRecordingState(null);
          reset();
        });
      }
    }

    // if (recordLocalState) {
    //   recordStart();
    // }
    // //録画停止
    // else {
    //   if (callObject != null) {
    //     callObject.stopRecording();
    //   }
    // }
  }, [recordLocalState]);

  //クラウド保存
  useEffect(() => {
    if (recordType.current != 'cloud') return;

    //録画開始
    if (recordLocalState) {
      //録画中の場合は何もしない
      if (recordingState == 'recording') return;

      recordCanvasStart();
      saveData(true);
      isRecordingRef.current = true;

      AddAccess('click', 'startRecordingCloud');
    }
    //録画停止
    else {
      if (recorderRef.current != null) {
        //最小サイズをクリアしていたら
        if (overMinSize.current) {
          //ステータス変更
          setRecordingState('finalize');
          //録画ストップ
          //recorderRef.current.stop();
          recorderRef.current.stopRecording(function () {});
          //ダウンロードURL表示用スクリーン表示
          setShowDownloadURL(true);
        } else {
          let status = window.confirm(t('top.Too short for recoring. Keep recording?'));
          if (status == false) {
            setRecordingState('cancel');
            recorderRef.current.stopRecording(function () {});
          } else {
            setRecordLocalState(true);
          }
        }
      }
    }
  }, [recordLocalState]);

  //Dailyの録画昨日
  async function recordStart() {
    if (canvasRef.current == null || callObject == null) return;

    const canvas = canvasRef.current;

    // canvas.captureStream(30).getTracks()[0];

    callObject
      .setInputDevicesAsync({
        videoSource: canvas.captureStream(30).getTracks()[0],
      })
      .then((status) => {
        console.log('ステータス');
        console.log(status);
        // console.log(data);
        callObject.startRecording({
          width: 1280,
          height: 720,
          videoBitrate: 1280,
          audioBitrate: 6400,
          fps: 30,
          layout: {
            preset: 'single-participant',
            session_id: localSessionId,
          },
        });
      });

    // console.log(trackName);
    //callObject.setLocalVideo(true);
  }

  //値のリセット
  async function reset() {
    //データベースに保存(録画終了通知)
    saveData(false);

    if (audioContext.current == null) return;

    //各種初期化
    // audioContext.current.close().then(function () {
    recorderRef.current = null;
    recordingUsersRef.current = [];
    isRecordingRef.current = false;
    mediaData.current = [];
    mediaTypeRef.current = null;
    destinationNode.current = null;
    audioContext.current = null;
    audioSourceNode.current = null;
    overMinSize.current = false;
    mimeType.current = 'video/webm;codecs=vp9';
    recordedIDRef.current = null;
    //});
  }

  //新しくジョインした人の情報
  useDailyEvent(
    'participant-joined',

    (ev) => {
      // useCallback((ev) => {
      if (
        isRecordingRef.current &&
        ev.participant?.session_id != localSessionId &&
        ev.participant?.userData.userType != 'viewer' &&
        recordingUsersRef.current.includes(ev.participant?.session_id) == false
      ) {
        getAudioFromNewUser(ev.participant?.session_id);
      }
    },

    // }, []),
  );

  function getAudioFromNewUser(session_id) {
    //一秒後に処理する
    setTimeout(() => {
      //取得できない場合は再度行う
      if (typeof callObject.participants() === 'undefined') {
        getAudioFromNewUser(session_id);
        return;
      }
      const users = callObject.participants();

      Object.keys(users).forEach(function (key) {
        const data = users[key];

        if (data.session_id == session_id) {
          const tempStream = new MediaStream();

          if (
            data.tracks != null &&
            data.tracks.audio != null &&
            data.tracks.audio.persistentTrack != null
          ) {
            tempStream.addTrack(data.tracks.audio.persistentTrack);
            var aud = audioContext.current.createMediaStreamSource(tempStream);
            aud.connect(destinationNode.current);

            //配列に追加
            recordingUsersRef.current.push(data.session_id);
          }
        }
      });
    }, 3000);
  }

  //データベースに保存
  function saveData(isRecording) {
    //データベースに保存
    if (callObject != null) {
      callObject
        .getMeetingSession()
        .then(async (session) => {
          try {
            //自分の情報をseessionに登録
            await DataModel.saveSessionToRoom(
              null, //ルームID
              session.meetingSession.id, //ルームのセッションID
              localSessionId, //ユーザーのテンポラリーユーザーID
              null, //顔
              null, //背景
              null, //顔認識 <isFaceTrackingå>
              isRecording, //録画中
            );

            console.log('セッション保存完了');
          } catch (error) {
            console.log(error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  //録画スタート
  const recordCanvasStart = async () => {
    //録画中
    setRecordingState('recording');

    //録画オブジェクト
    const ms = new MediaStream();

    //キャンバスから映像取得
    const canvas = canvasRef.current;

    //const canvas = renderer.view;

    // const offscreenCanvas = canvas.transferControlToOffscreen();
    // //const offscreenCanvas = new OffscreenCanvas(canvasRef.current.width, canvasRef.current.height);
    // //const offscreenCtx = offscreenCanvas.getContext('2d');
    // sendCanvasToWorker(offscreenCanvas);

    // function sendCanvasToWorker(canvas) {
    //   const worker = new Worker('/js/worker.js');
    //   worker.postMessage({ canvas });
    //   worker.onmessage = function (event) {
    //     const message = event.data;
    //     if (message.type === 'recordingComplete') {
    //       const videoURL = URL.createObjectURL(message.blob);
    //       const downloadLink = document.createElement('a');
    //       downloadLink.href = videoURL;
    //       downloadLink.download = 'recorded_video.webm';
    //       document.body.appendChild(downloadLink);
    //       downloadLink.click();
    //       document.body.removeChild(downloadLink);
    //     }
    //   };
    // }

    // return;
    // var ctx1 = canvas1.getContext('2d');
    // console.log(ctx1);

    // var canvas = canvasRef.current.cloneNode();

    //const offscreenCanvas = canvasRef.current.transferControlToOffscreen();
    //const offscreen = new OffscreenCanvas(canvasRef.current.width, canvasRef.current.height);
    //const offscreenCtx = offscreen.getContext('2d');
    //offscreen.transferToImageBitmap();
    //
    // copy = original.cloneNode();  // Copy the canvas dimensions.

    // init an 2D context
    //  var ctx = canvas.getContext('2d');

    //console.log(ctx);

    // var worker = new Worker('js/worker.js');
    // worker.addEventListener(
    //   'message',
    //   function (e) {
    //     let diff = e.data;
    //     //modelRef.current.update(diff);

    //     // console.log('どうも');

    //     offscreenCtx.clearRect(0, 0, offscreen.width, offscreen.height);
    //     offscreenCtx.drawImage(canvasRef.current, 0, 0);

    //     //canvas.getContext('2d').drawImage(canvasRef.current, 0, 0); // C
    //   },
    //   false,
    // );

    // // Workerにメッセージを送信
    // worker.postMessage('ddd');

    //const bitmapRenderer = offscreen.transferToImageBitmap().getContext('bitmaprenderer');
    //const stream = ;
    ms.addTrack(canvas.captureStream(30).getTracks()[0]); //30FPSで設定
    // ms.addTrack(bitmapRenderer.canvas.captureStream().getTracks()[0]); //30FPSで設定

    //各ユーザーの音声を取得
    const users = callObject.participants();

    //ミックス用オーディオ(webmの場合は同じタイプのトラックを２つ以上使えないため、マージする必要がある)
    audioContext.current = new AudioContext();
    destinationNode.current = audioContext.current.createMediaStreamDestination();

    Object.keys(users).forEach(function (key) {
      const data = users[key];

      //ビューワーではない場合
      if (data.userData?.userType != 'viewer') {
        //音声をトラックに追加（新しいメディアストリーム作成）
        const tempStream = new MediaStream();

        if (
          data.tracks != null &&
          data.tracks.audio != null &&
          data.tracks.audio.persistentTrack != null
        ) {
          tempStream.addTrack(data.tracks.audio.persistentTrack);
          audioSourceNode.current = audioContext.current.createMediaStreamSource(tempStream);
          audioSourceNode.current.connect(destinationNode.current);

          //配列に追加
          recordingUsersRef.current.push(data.session_id);
        }
      }

      //スクリーン動画があるばあい
      if (data['screenVideoTrack'] != null) {
        //音声をトラックに追加
        ms.addTrack(data['screenVideoTrack']);
      }
    });

    //マージした音声を本番用のメディアストリームに追加

    ms.addTrack(destinationNode.current.stream.getAudioTracks()[0]);

    //メディアタイプのサポートチェック
    mimeType.current = 'video/webm;codecs=vp9';

    if (MediaRecorder.isTypeSupported('video/webm;codecs=vp9')) {
    } else if (MediaRecorder.isTypeSupported('video/webm;codecs=vp8')) {
      mimeType.current = 'video/webm;codecs=vp8';
    } else if (MediaRecorder.isTypeSupported('video/webm')) {
      mimeType.current = 'video/webm';
    } else {
      //Safari用
      mimeType.current = 'video/mp4';
    }

    if (recordType.current == 'cloud') {
      //クラウド
      saveCloud(ms);
    } else {
      //ローカル
      saveLocal(ms);
    }
  };

  //ローカルでの録画
  async function saveLocal(ms) {
    //コーデックをここで指定
    let options = {
      type: 'video',
      mimeType: mimeType.current,
      // audioBitsPerSecond: 16 * 1000,
      //videoBitsPerSecond: 256 * 8 * 1024,
      bitsPerSecond: 256800,
      frameInterval: 30,
      timeSlice: 5000,
      ondataavailable: function (blob) {},
    };

    //初期化
    recorderRef.current = RecordRTC(ms, options);

    //録画開始
    recorderRef.current.startRecording();

    //状況変化の検知
    recorderRef.current.onStateChanged = (state) => {
      console.log('録画状況辺境');
      console.log(state);
    };

    setTopMessageState({
      type: 'joined',
      message: t('top.Recording Started'),
    });

    //const sleep = (m) => new Promise((r) => setTimeout(r, m));
    //await sleep(3000);

    //録画処理初期化
    /*
    recorderRef.current = new MediaRecorder(ms, options);

    //データ取得のたびに呼ばれる
    recorderRef.current.ondataavailable = async (e) => {
      mediaTypeRef.current = e.data.type;
      mediaData.current.push(e.data);
    };

    //エラー時の処理(メモリーエラーなど)
    recorderRef.current.onerror = async (event) => {
      console.error(`error recording stream: ${event.error.name}`);
      await stopRecord();
      reset();
      setRecordLocalState(false);
    };

    //レコーダーがストップしたときに呼ばれる
    recorderRef.current.onstop = async () => {
      await stopRecord();
      reset();
    };

    //レコードスタート(ミリセコンドを入れると、細切れに保存していく。
    recorderRef.current.start(15000);

    setTopMessageState({
      type: 'joined',
      message: t('top.Recording Started'),
    });
    */
  }

  //ローカル保存
  async function stopRecord() {
    //レコーダー停止

    //データをBlobに変換
    const blob = new Blob(mediaData.current, { type: mediaTypeRef.current });

    //保存する
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    if (mimeType.current == 'video/mp4') {
      a.download = `FACELESS-Video.mp4`;
    } else {
      a.download = `FACELESS-Video.webm`;
    }

    a.href = url;
    a.click();

    return true;
  }

  //クラウドに保存
  async function saveCloud(ms) {
    //let kk = new RecordRTC(ms, options);

    //ファイル名
    var fileName = 'row/test.webm';
    var uniqueName = localSessionId + String(Math.floor(Math.random() * 100000) + 1); //new Date().toISOString();
    var hlsURL = '';
    var mp4URL;
    var baseURL = 'https://faceless-video.s3.us-west-2.amazonaws.com';
    var hlsURLBefore = baseURL + '/hls/'; //'https://faceless-video.s3.us-west-2.amazonaws.com/hls/';
    if (mimeType.current == 'video/mp4') {
      fileName = 'row/' + uniqueName + '.mp4';
      mp4URL = baseURL + '/mp4/' + uniqueName + '/' + uniqueName + '.mp4';
      hlsURL = hlsURLBefore + uniqueName + '/' + uniqueName + '_hls.m3u8';
    } else {
      fileName = 'row/' + uniqueName + '.webm';
      mp4URL = baseURL + '/mp4/' + uniqueName + '/' + uniqueName + '.mp4';
      hlsURL = hlsURLBefore + uniqueName + '/' + uniqueName + '_hls.m3u8';
    }

    //1.アップロード開始
    let uploadID;
    let recordedID;
    var EtagArray = [];
    var index = 0;
    let minSize = 5 * 1024 * 1024; //5MBが最低必要
    var promiseArray = [];

    try {
      //ミーティングのセッションID取得
      if (callObject == null) return;
      let session;
      try {
        session = await callObject.getMeetingSession();
      } catch (e) {}
      var roomID = urlParam.id; //URL取得

      //DB追加
      const result = await DataModel.awsUploadStart(
        fileName,
        roomID,
        session.meetingSession.id,
        uniqueName,
        hlsURL,
        mp4URL,
      );
      if (result?.uploadID != null) {
        uploadID = result?.uploadID;
        recordedID = result?.recordedID;
      }
    } catch (e) {
      console.log(e);
      return;
    }

    //コーデックをここで指定
    let options = {
      mimeType: mimeType.current,
      bitsPerSecond: 256000, //2000000, //256000,
      frameInterval: 30,
      timeSlice: 5000, // pass this parameter
      // getNativeBlob: true,
      ondataavailable: function (blob) {
        //各処理はプロミスにして並列処理に
        let promise = new Promise(async (resolve, reject) => {
          //配列に追加
          mediaData.current.push(blob);

          // var reader = new FileReader();
          // reader.readAsArrayBuffer(blob);
          // reader.onloadend = function () {
          //   var buffer = reader.result;
          //   console.log('ここきた');
          //   console.log(buffer);
          // };

          //Blobに変換
          // const blob = new Blob(mediaData.current, { type: mimeType.current });
          //console.log('サイズ:' + blob.size);

          var size = 0;
          mediaData.current.forEach(function (b) {
            size += b.size;
          });

          //サイズチェック
          if (size < minSize && recordingState != 'finalize') {
            console.log(size);
            resolve(true);
            return;
          }

          //最小ファイルサイズの制限をクリア
          overMinSize.current = true;

          let finalBlobArray = mediaData.current;

          //配列を空にする
          mediaData.current = [];

          //部分番号
          let partNumber = index + 1;

          //indexを増加
          index++;

          //2. 署名付きURLを取得
          let signedURL;
          try {
            const result = await DataModel.awsUploadGetURL(
              fileName,
              uploadID,
              partNumber,
              blob.type,
            );
            if (result?.signedURL != null) {
              signedURL = result?.signedURL;
            } else {
              return;
            }
          } catch (e) {
            console.log(e);
            return;
          }

          //3. ファイルを個別アップロード (To-do アップロード失敗時のリトライ)
          let uploadResult;

          // var blobArray = [];

          // const filePromises = mediaData.current.forEach((currentBlob) => {
          //   // Return a promise per file
          //   return new Promise((resolve, reject) => {
          //     const reader = new FileReader();
          //     reader.readAsArrayBuffer(currentBlob);
          //     reader.onloadend = async () => {
          //       var buffer = reader.result;
          //       console.log('ここきた');
          //       console.log(buffer);
          //       blobArray.push(buffer);
          //       resolve(true);
          //     };
          //     reader.onerror = (error) => {
          //       reject(error);
          //     };
          //   });
          // });

          // Wait for all promises to be resolved
          // const fileInfos = await Promise.all(filePromises);

          // mediaData.current.forEach(async (currentBlob) => {
          //   // blobArray.push(getSeekableBlob(currentBlob));
          //   // var reader = new FileReader();
          //   // reader.readAsArrayBuffer(currentBlob);
          //   // reader.onloadend = function () {
          //   //   var buffer = reader.result;
          //   //   console.log('ここきた');
          //   //   console.log(buffer);
          //   // };
          // });

          // var blobArray = fromBlobToData();

          // console.log(blobArray);

          const blobs = new Blob(finalBlobArray, { type: blob.type });

          try {
            uploadResult = await axios.put(signedURL, blobs, {
              headers: {
                'Content-Type': blob.type, //'multipart/form-data', //mimeType.current,
              },
            });
          } catch (e) {
            console.log(e);
            return;
          }

          //ETag取得
          let etag = uploadResult.headers.etag;

          //配列に追加
          EtagArray.push({ ETag: etag, PartNumber: partNumber });

          //完了通知
          const result = await DataModel.partRecordedVideo(recordedID, EtagArray);

          console.log('個別アップロード完了');

          //リターン
          resolve(true);

          //3-B 別のリクエストの仕方
          // const headers = {
          //   'Content-Type': e.data.type, //'multipart/form-data',
          // };

          // const etag = await fetch(signedURL, {
          //   method: 'PUT',
          //   headers,
          //   body: blob,
          // }).then((response) => response.headers.get('ETag'));
        });

        //プロミス用配列に追加
        promiseArray.push(promise);
      },
    };

    //初期化
    recorderRef.current = RecordRTC(ms, options);

    // let kk = new RecordRTC(ms, options);

    // kk.getFromDisk();

    // kk.getInternalRecorder();

    //録画開始
    recorderRef.current.startRecording();

    // let internal = recorderRef.current.getInternalRecorder();

    //状況変化の検知
    recorderRef.current.onStateChanged = async (state) => {
      if (state == 'stopped') {
        //キャンセルの場合
        if (recordingState == 'cancel') {
          //const result = await DataModel.abortRecordedVideo(fileName, uploadID);
          console.log('録画キャンセル完了');
          setShowDownloadURL(false);
          //値のリセット
          setRecordingState(null);
          //reset();
        } else {
          //並列処理をすべて終了したあとに行う
          let status = await Promise.all(promiseArray);

          const result = await DataModel.completeRecordedVideo(
            recordedID,
            fileName,
            uploadID,
            EtagArray,
          );

          console.log('タグ配列');
          console.log(EtagArray);

          if (result) {
            videoURL.current = recordedID;

            //ステータス変更
            setRecordingState('completed');
            console.log('アップロード完了');
          } else {
            setRecordingState(null);
            console.log('アップロード失敗');
          }
        }

        //値のリセット
        reset();
      }
    };

    setTopMessageState({
      type: 'joined',
      message: t('top.Recording Started'),
    });

    const sleep = (m) => new Promise((r) => setTimeout(r, m));
    await sleep(3000);

    return;

    //エラー時の処理(メモリーエラーなど)
    recorderRef.current.onerror = async (event) => {
      console.error(`error recording stream: ${event.error.name}`);

      //エラーが起きると、一部アップロードしていたファイルが残っていると課金されるので、ファイルを削除
      if (uploadID) {
        //const result = await DataModel.abortRecordedVideo(fileName, uploadID);
        showDownloadURL(false);
      }
      reset();
      setRecordLocalState(false);
      console.log('録画エラー - キャンセル完了');
    };

    //レコーダーがストップしたときに呼ばれる
    recorderRef.current.onstop = async () => {
      //キャンセルの場合
      if (recordingState == 'cancel') {
        //const result = await DataModel.abortRecordedVideo(fileName, uploadID);
        showDownloadURL(false);
        console.log('録画キャンセル完了');
      } else {
        //並列処理をすべて終了したあとに行う
        let status = await Promise.all(promiseArray);

        const result = await DataModel.completeRecordedVideo(
          recordedID,
          fileName,
          uploadID,
          EtagArray,
        );

        if (result) {
          videoURL.current = recordedID;

          //ステータス変更
          setRecordingState('completed');
          console.log('アップロード完了');
        } else {
          console.log('アップロード失敗');
        }
      }

      //値のリセット
      reset();
    };

    //レコードスタート(ミリセコンドを入れると、細切れに保存していく。
    //recorderRef.current.start(5000);

    setTopMessageState({
      type: 'joined',
      message: t('top.Recording Started'),
    });
  }

  // async function fromBlobToData() {
  //   var data = [];
  //   mediaData.current.forEach(async (currentBlob) => {
  //     // blobArray.push(getSeekableBlob(currentBlob));

  //     var reader = new FileReader();
  //     reader.readAsArrayBuffer(currentBlob);
  //     reader.onloadend = function () {
  //       var buffer = reader.result;
  //       data.push(data);
  //     };
  //   });

  //   return data;
  // }

  /*
  //クラウドにアップロード
  async function saveCloud2(ms) {
    //ファイル名
    var fileName = 'row/test.webm';
    var uniqueName = localSessionId + String(Math.floor(Math.random() * 100000) + 1); //new Date().toISOString();
    var hlsURL = '';
    var hlsURLBefore = 'https://faceless-video.s3.us-west-2.amazonaws.com/hls/'; //'https://faceless-video.s3.us-west-2.amazonaws.com/hls/';
    if (mimeType.current == 'video/mp4') {
      fileName = 'row/' + uniqueName + '.mp4';
      hlsURL = hlsURLBefore + uniqueName + '/' + uniqueName + '_hls.m3u8';
    } else {
      fileName = 'row/' + uniqueName + '.webm';
      hlsURL = hlsURLBefore + uniqueName + '/' + uniqueName + '_hls.m3u8';
    }

    //1.アップロード開始
    let uploadID;
    let recordedID;
    try {
      //ミーティングのセッションID取得
      if (callObject == null) return;
      let session;
      try {
        session = await callObject.getMeetingSession();
      } catch (e) {}
      var roomID = urlParam.id; //URL取得

      //DB追加
      const result = await DataModel.awsUploadStart(
        fileName,
        roomID,
        session.meetingSession.id,
        uniqueName,
        hlsURL,
      );
      if (result?.uploadID != null) {
        uploadID = result?.uploadID;
        recordedID = result?.recordedID;
      }
    } catch (e) {
      console.log(e);
      return;
    }

    //コーデックをここで指定
    let options = {
      mimeType: mimeType.current,
      bitsPerSecond: 2560000,
      frameInterval: 30,
    };

    //録画処理初期化
    recorderRef.current = new MediaRecorder(ms, options);

    //データが取得可能なった場合
    var EtagArray = [];
    var index = 0;
    let minSize = 5 * 1024 * 1024; //5MBが最低必要
    var promiseArray = [];

    //データ取得のたびに呼ばれる
    recorderRef.current.ondataavailable = async (e) => {
      //各処理はプロミスにして並列処理に
      let promise = new Promise(async (resolve, reject) => {
        //配列に追加
        mediaData.current.push(e.data);

        //Blobに変換
        const blob = new Blob(mediaData.current, { type: e.data.type });
        console.log('サイズ:' + blob.size);

        //サイズチェック
        if (blob.size < minSize && recordingState != 'finalize') {
          resolve(true);
          return;
        }

        //最小ファイルサイズの制限をクリア
        overMinSize.current = true;

        //配列を空にする
        mediaData.current = [];

        //部分番号
        let partNumber = index + 1;

        //indexを増加
        index++;

        //2. 署名付きURLを取得
        let signedURL;
        try {
          console.log(fileName);
          const result = await DataModel.awsUploadGetURL(
            fileName,
            uploadID,
            partNumber,
            e.data.type,
          );
          if (result?.signedURL != null) {
            signedURL = result?.signedURL;
          } else {
            return;
          }
        } catch (e) {
          console.log(e);
          return;
        }

        //3. ファイルを個別アップロード (To-do アップロード失敗時のリトライ)
        let uploadResult;
        try {
          uploadResult = await axios.put(signedURL, blob, {
            headers: {
              'Content-Type': e.data.type, //'multipart/form-data', //mimeType.current,
            },
          });
        } catch (e) {
          console.log(e);
          return;
        }

        //ETag取得
        let etag = uploadResult.headers.etag;

        //配列に追加
        EtagArray.push({ ETag: etag, PartNumber: partNumber });

        //完了通知
        const result = await DataModel.partRecordedVideo(recordedID, EtagArray);

        console.log('個別アップロード完了');

        //リターン
        resolve(true);

        //3-B 別のリクエストの仕方
        // const headers = {
        //   'Content-Type': e.data.type, //'multipart/form-data',
        // };

        // const etag = await fetch(signedURL, {
        //   method: 'PUT',
        //   headers,
        //   body: blob,
        // }).then((response) => response.headers.get('ETag'));
      });

      //プロミス用配列に追加
      promiseArray.push(promise);
    };

    //エラー時の処理(メモリーエラーなど)
    recorderRef.current.onerror = async (event) => {
      console.error(`error recording stream: ${event.error.name}`);

      //エラーが起きると、一部アップロードしていたファイルが残っていると課金されるので、ファイルを削除
      if (uploadID) {
        //const result = await DataModel.abortRecordedVideo(fileName, uploadID);
        setShowDownloadURL(false);
      }
      reset();
      setRecordLocalState(false);
      console.log('録画エラー - キャンセル完了');
    };

    //レコーダーがストップしたときに呼ばれる
    recorderRef.current.onstop = async () => {
      //キャンセルの場合
      if (recordingState == 'cancel') {
        //const result = await DataModel.abortRecordedVideo(fileName, uploadID);
        showDownloadURL(false);
        console.log('録画キャンセル完了');
      } else {
        //並列処理をすべて終了したあとに行う
        let status = await Promise.all(promiseArray);

        const result = await DataModel.completeRecordedVideo(
          recordedID,
          fileName,
          uploadID,
          EtagArray,
        );

        if (result) {
          videoURL.current = recordedID;

          //ステータス変更
          setRecordingState('completed');
          console.log('アップロード完了');
        } else {
          console.log('アップロード失敗');
        }
      }

      //値のリセット
      reset();
    };

    //レコードスタート(ミリセコンドを入れると、細切れに保存していく。
    recorderRef.current.start(5000);

    setTopMessageState({
      type: 'joined',
      message: t('top.Recording Started'),
    });
  }


  //クラウドにアップロード
  async function saveCloud(ms) {
    //saveCloud2(ms);
    //return;
    //MediaConvert → Lamda → HLS変換の参考→　https://zenn.dev/jinwatanabe/articles/44f0906c6f317b

    //サーバー側で処理した後にAWSに送る(実装予定) https://gist.github.com/nickwild-999/c89cfdc3b9edf5f9a8175381ffd79943

    let backetName = 'faceless-video'; //バケット名
    let region = 'us-west-2';

    //AWSキー

    //ファイル名
    var fileName = 'row/test.webm';
    var uniqueName = localSessionId + String(Math.floor(Math.random() * 100000) + 1); //new Date().toISOString();
    var hlsURL = '';
    var hlsURLBefore = 'https://faceless-video.s3.us-west-2.amazonaws.com/hls/'; //'https://faceless-video.s3.us-west-2.amazonaws.com/hls/';
    if (mimeType.current == 'video/mp4') {
      fileName = 'row/' + uniqueName + '.mp4';
      hlsURL = hlsURLBefore + uniqueName + '/' + uniqueName + '_hls.m3u8';
    } else {
      fileName = 'row/' + uniqueName + '.webm';
      hlsURL = hlsURLBefore + uniqueName + '/' + uniqueName + '_hls.m3u8';
    }

    const params = {
      Bucket: backetName,
      Key: fileName,
    };

    //1. 初期化(uploadIDを取得)
    let s3 = new S3({ region: region, credentials: creds });

    let multi;
    try {
      multi = await s3.createMultipartUpload(params).promise();
    } catch (e) {
      alert('Error - Something wrong');
      return;
    }

    //アップロードID
    let uploadID = multi.UploadId;

    //コーデックをここで指定
    let options = {
      mimeType: mimeType.current,
      // audioBitsPerSecond: 16 * 1000,
      //videoBitsPerSecond: 256 * 8 * 1024,
      bitsPerSecond: 2560000,
      // frameInterval: 30,
    };

    //録画処理初期化
    recorderRef.current = new MediaRecorder(ms, options);

    //データが取得可能なった場合
    var EtagArray = [];
    var index = 0;
    let minSize = 5 * 1024 * 1024; //5MBが最低必要
    var promiseArray = [];

    //データ取得のたびに呼ばれる
    recorderRef.current.ondataavailable = async (e) => {
      //各処理はプロミスにして並列処理に
      let promise = new Promise(async (resolve, reject) => {
        //配列に追加
        mediaData.current.push(e.data);

        //Blobに変換
        const blob = new Blob(mediaData.current, { type: e.data.type });
        // const blob = new Blob([e.data], { type: e.data.type });
        // console.log('サイズ:' + blob.size + ' 番号:' + partNumber);

        console.log('サイズ:' + blob.size);

        //サイズチェック
        if (blob.size < minSize && recordingState != 'finalize') {
          resolve(true);
          return;
        }

        //最小ファイルサイズの制限をクリア
        overMinSize.current = true;

        //配列を空にする
        mediaData.current = [];

        //部分番号
        let partNumber = index + 1;

        //indexを増加
        index++;

        //一部をアップロード
        const result = await s3
          .uploadPart({
            Body: blob,
            Bucket: backetName,
            Key: fileName,
            PartNumber: partNumber,
            UploadId: uploadID,
            ContentLength: blob.size,
          })
          .promise();

        console.log('一部アップロード完了:' + partNumber);

        //配列に追加
        EtagArray.push({ ETag: result['ETag'], PartNumber: partNumber });

        resolve(true);
      });

      promiseArray.push(promise);
    };

    //エラー時の処理(メモリーエラーなど)
    recorderRef.current.onerror = async (event) => {
      console.error(`error recording stream: ${event.error.name}`);

      //エラーが起きると、一部アップロードしていたファイルが残っていると課金されるので、ファイルを削除
      if (uploadID) {
        s3.abortMultipartUpload({
          Bucket: backetName,
          UploadId: uploadID,
          Key: fileName,
        })
          .promise()
          .then(() => console.log('Multipart upload aborted'))
          .catch((e) => console.error(e));

        showDownloadURL(false);
      }

      reset();

      setRecordLocalState(false);
    };

    //レコーダーがストップしたときに呼ばれる
    recorderRef.current.onstop = async () => {
      //キャンセルの場合
      if (recordingState == 'cancel') {
        let status = await s3
          .abortMultipartUpload({
            Bucket: backetName,
            UploadId: uploadID,
            Key: fileName,
          })
          .promise();

        showDownloadURL(false);

        console.log('録画キャンセル完了');
      } else {
        //並列処理をすべて終了したあとに行う
        let status = await Promise.all(promiseArray);

        await s3
          .completeMultipartUpload({
            Bucket: backetName,
            Key: fileName,
            UploadId: uploadID,
            MultipartUpload: {
              Parts: EtagArray,
            },
          })
          .promise();

        //ミーティングのセッションID取得
        if (callObject == null) return;
        let session;
        try {
          session = await callObject.getMeetingSession();
        } catch (e) {}

        //データベースに保存
        var roomID = urlParam.id; //URL取得
        let result = await DataModel.saveRecordCloud(
          roomID,
          fileName,
          hlsURL,
          uniqueName,
          session.meetingSession.id,
        );

        if (result.docID != null) {
          videoURL.current = result.docID;

          //ステータス変更
          setRecordingState('completed');

          console.log('アップロード完了');
        } else {
          console.log('アップロード失敗');
        }
      }

      //値のリセット
      reset();
    };

    //レコードスタート(ミリセコンドを入れると、細切れに保存していく。
    recorderRef.current.start(5000);

    setTopMessageState({
      type: 'joined',
      message: t('top.Recording Started'),
    });
  }

  */

  //クリップボードにコピー
  const copyURL = () => {
    var url = 'https://faceless.ooo/r/' + videoURL.current;

    navigator.clipboard.writeText(url).then(
      function () {
        setTopMessageState({ type: 'copied', message: t('top.Copied Successfully') });
        AddAccess('click', 'copiedURL');
      },
      function (err) {},
    );
  };
  return !showDownloadURL ? (
    false
  ) : (
    <>
      <div className="backGridWrap">
        <div className="backGridInside">
          {recordingState == 'finalize' && (
            <>
              <div className="recordedTitle">{t('call.Uploading recorded video...')} </div>
              <div className="recordedLoader">
                <div className="loader">
                  <svg className="circular-loader" viewBox="25 25 50 50">
                    <circle
                      className="loader-path-gray"
                      cx="50"
                      cy="50"
                      r="20"
                      fill="none"
                      stroke="#70c542"
                      strokeWidth="2"
                    />
                  </svg>
                </div>
              </div>
              <button
                className="recordedCancelButton"
                onClick={() => {
                  setRecordingState('cancel');
                  recorderRef.current.stopRecording(function () {});
                }}>
                {t('call.Cancel')}
              </button>
            </>
          )}

          {recordingState == 'completed' && (
            <>
              <div className="recordedTitle" style={{ color: '#000' }}>
                {t('call.Uploaded succesfully!')}
              </div>
              <div className="recordedURLBody">
                {t('call.It takes a while to complete the conversion')}
              </div>
              <div className="recordedURLText"> {t('call.Video URL')}</div>
              <div className="electronURLWrap" onClick={() => copyURL()}>
                <div className="urlInside">faceless.ooo/r/{videoURL.current}</div>
                <div className="IDCopy">
                  <CopyLinkSVG />
                </div>
              </div>
              <button
                className="recordedCancelButton"
                onClick={() => {
                  setRecordingState(null);
                  setShowDownloadURL(false);
                }}
                style={{ marginTop: '20px' }}>
                {t('setting.Close')}
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
}
